module.exports = __webpack_public_path__ + "img/geomaps-01.324e7bfc.png";